import * as xss from 'xss';

/**
	* Cleans the string preventing XSS attacks.
	* @param html string that contains html
	* @returns string with clean html
	*/
export function sanitizeHtml(html: string, {
	whiteList = xss.getDefaultWhiteList(),
} = {}): string {
	whiteList.a?.push(
		'id',
		'name',
		'rel', // Needed for rel="external"
	);
	whiteList.span?.push('class'); // Needed for sr-only
	// console.debug('sanitizeHtml: whiteList', whiteList); // Yes <br/> is allowed.
	return new xss.FilterXSS({
		allowCommentTag: true,
		escapeHtml: (text) => text,
		whiteList,
	}).process(html);
}
